import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";
import { RiskItem } from "../shared/RiskList";

// const atomList = ["albumin", "lipase", "amylase", "alt", "sgot", "alp", "ggt"];
const labList = [
  "Albumin",
  "Bilirubin",
  "Lipase",
  "Amylase",
  "ALT",
  "SGOT",
  "ALP",
  "GGT"
];

const labRanges = [];

@Component({})
export default class Liver extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("current", patientNamespace)
  currentPatient!: Patient;

  get liverLabs(): Array<RiskItem> {
    if (!this.currentPatient || !this.currentPatient.body) {
      return [];
    }
    const atoms = this.currentPatient.body.atoms;

    const result = labList
      .map(labName => {
        return labName.toLowerCase();
      })
      .filter(atomName => {
        return atoms[atomName] && atoms[atomName].legend;
      })
      .map(atomName => {
        const atom = atoms[atomName];

        // Make 3 (normally green) gray
        const level = atom.level === 3 ? 0 : atom.level;
        return {
          label: atom.legend,
          level: level
        };
      });
    return result;
  }

  @Getter("graph", patientNamespace)
  graph!: any;

  get charts(): MultiChartConfig[] {
    return this.graph(labList).map((m: any) => {
      return { title: m.label, data: [m] };
    });
  }

  created() {
    this.selectedTime = 3 * 24;
  }
}
